import { AccountSettingsContent } from "@/components/account/account-settings-content";
import { PageHeader } from "@/components/shared/page-header";

export default function AdminAccountPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Account Settings" />
      <AccountSettingsContent />
    </div>
  );
}
